/** * @Author: liujiannan * @Date: 2020-09-08 15:31:42 * @Description:
预约模块按医生选择列表 */
<template>
  <div class="appointment-type-list-doctor">
    <div
      v-for="(item, index) in list"
      :key="index"
      @click="goToDoctorList(item)"
      class="appointment-type-list-doctor-item"
    >
      <van-image :src="item.portrait" class="doctor-protrait" alt="">
        <img slot="error" :src="require('@assets/ic_doctor.png')" alt="" />
      </van-image>
      <div class="appointment-type-list-doctor-info">
        <div>
          <span class="appointment-type-list-doctor-name">
            {{ item.title }}
          </span>
          <span class="appointment-type-list-doctor-title">
            {{ item.level }}
          </span>
        </div>
        <div class="appointment-type-list-doctor-department">
          坐诊科室：{{ item.department }}
        </div>
        <div class="appointment-type-list-doctor-introduce van-ellipsis">
          {{ item.intro }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    qrtype: {
      type: String,
      default: "1",
    },
    list: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    goToDoctorList(item) {
      window.localStorage.setItem("cargo", "");
      this.$router.push({
        name: "appointment-schedule-doctor",
        query: {
          ...item,
          qrtype: this.qrtype,
        },
      });
    },
  },
};
</script>

<style lang="less">
.appointment-type-list-doctor {
  > div {
    display: flex;
    padding: 0.5rem 0;
    background-color: white;
    border-radius: 8px;
  }

  &-info {
    width: calc(100% - 5rem);
  }

  .doctor-protrait {
    margin: 0 1rem;
    img {
      overflow: hidden;
      border-radius: 50%;
    }
  }

  &-name {
    font-weight: bold;
    font-size: 0.91rem;
  }

  &-title {
    margin-left: 0.8rem;
    color: white;
    font-size: 0.88rem;
    font-size: 0.9rem;
    background-color: #108eee;
    border-radius: 2px;
  }

  &-department {
    margin-top: 0.3rem;
    font-size: 0.94rem;
    font-size: 0.9rem;
  }

  &-introduce {
    margin: 6px 0 5px 0;
    overflow: hidden;
    color: #999;
    font-size: 0.82rem;
  }
}
</style>
